export const DOMAIN_NAME = 'teamManagement';
export const TEAM_ROUTE_ID = 41;

export const API_ENDPOINTS = {
    GET_ALL: '/team/get/all',
    GET_BY_ID: '/team/get',
    GET_DETAIL: '/team/get',
    CREATE: '/team/create',
    UPDATE: '/team/update',
    DELETE: '/team/delete'
};

export const ACTIVE_STATUS_FILTER_OPTIONS = [
    { value: '', label: 'All' },
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' }
];

export const TABLE_COLUMNS = [
    { id: 'name', label: 'Name', sortable: true, minWidth: 200 },
    { id: 'description', label: 'Description', sortable: true, minWidth: 260 },
    { id: 'memberCount', label: 'Members', sortable: true, minWidth: 100, align: 'center' },
    { id: 'isActive', label: 'Status', sortable: true, minWidth: 100, align: 'center' },
    { id: 'updatedAt', label: 'Updated At', sortable: true, minWidth: 140 },
    { id: 'actions', label: 'Actions', sortable: false, minWidth: 100, align: 'center' }
];

export const SORT_BY_OPTIONS = [
    { value: 'updatedAt', label: 'Updated At' },
    { value: 'createdAt', label: 'Created At' },
    { value: 'name', label: 'Name' },
    { value: 'description', label: 'Description' },
    { value: 'isActive', label: 'Status' },
    { value: 'memberCount', label: 'Members' }
];

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

export const getErrorMessage = (error, defaultMessage) => {
    if (error?.response?.data?.message && typeof error.response.data.message === 'string') {
        return error.response.data.message;
    }
    if (error?.message) return error.message;
    return defaultMessage;
};
